import { render, staticRenderFns } from "./SupplierFooter.vue?vue&type=template&id=15218de3&scoped=true&"
import script from "./SupplierFooter.vue?vue&type=script&lang=js&"
export * from "./SupplierFooter.vue?vue&type=script&lang=js&"
import style0 from "./SupplierFooter.vue?vue&type=style&index=0&id=15218de3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15218de3",
  null
  
)

export default component.exports